import { HStack } from '@sgme/ui';

import { useUserContext } from '@/context/UserContext.tsx';
import type { BlotterType } from '@/store/blotter/types/index.ts';

import { DateFilter } from './DateFilter.tsx';
import { OnlyMyDealsFilter } from './OnlyMyDealsFilter.tsx';

type Props = {
  activeTab: BlotterType;
};

export const BlotterFilters = ({ activeTab }: Props) => {
  const user = useUserContext();
  const showDateFilter = activeTab !== 'Order' && user.currentUser.userType !== 'Internal Sales';
  return (
    // overflow-visible to allow the date range picker of the "historical filter" to show its selection panel
    <HStack gap="8px" className="overflow-visible">
      {showDateFilter && <DateFilter />} <OnlyMyDealsFilter />
    </HStack>
  );
};
